// desktop dropdown positioning check
window.addEventListener('DOMContentLoaded', function() {
    // desktop search
  
    $('[js-click="show-search"]').click(function () {
      $('[js-target="search"]').toggleClass('active');
      $('[js-change="search-input"]').focus();
    });
  
    $('[js-click="close-search"]').click(function () {
      $('[js-target="search"]').removeClass('active');
    });
  
    $('[js-change="search-input"]').on('input', function () {
      $('[js-target="search-form"]').addClass('searched');
    });
  
    $('[js-change="search-input"]').on('focus', function () {
      $(this).select();
    });
  
    // open mobile navigation
  
    $('.wmwnav__hamburger').click(function () {
      if (!$(this).parent().parent().hasClass('open_nav')) {
        $("html, body").animate({ scrollTop: 0 }, '200');
  
        $(this).parent().parent().addClass('open_nav');
        $(this).parent().parent().parent().addClass('open_nav');
        $('.mobile-nav').addClass('open_nav');
  
        var dropdownHeight = $('.mobile-nav').height();
        var navHeight = (dropdownHeight + 180);
  
        $('.wmwnav__dropdown').css('height', dropdownHeight);
        $('.section-wrapper').hide()
        $('#shopify-section-adreno-footer').hide()
        $('#page').css('height', navHeight);
        $('#page').addClass('nav-open');
        $('body').append('<div class="nav-overlay"></div>');
      } else {
        $(this).parent().parent().removeClass('open_nav');
        $(this).parent().parent().parent().removeClass('open_nav');
        $('.mobile-nav').removeClass('open_nav');
  
        $('.wmwnav__dropdown').css('height', '0');
        $('.section-wrapper').show()
        $('#shopify-section-adreno-footer').show()
        $('#page').css('height', 'auto');
        $('#page').removeClass('nav-open');
        $('.nav-overlay').remove();
  
        $('.wmwnav__sub').removeClass('nav_open');
        $('.mobile-nav').removeClass('child_open');
        $('.mobile-nav').removeClass('grandchild_open');
      }
  
      $('.cart-preview').hide();
    });
  
    // mobile dropdown 
  
    $('.nav_button').click(function () {
      window.scrollTo(0, 0);
      var handle = $(this).attr('data-handle');
  
      if (!$('.nav-' + handle).hasClass('nav_open')) {
        // set height of container
        var dropdownHeight = $('.nav-' + handle).height();
        var navHeight = (dropdownHeight + 180);
        $('.wmwnav__dropdown').css('height', dropdownHeight);
        $('#page').css('height', navHeight);
  
        // open sub menu
        $('.nav-' + handle).addClass('nav_open');
  
        if ($('.nav-' + handle).hasClass('child_nav')) {
          $('.mobile-nav').addClass('child_open');
        } else if ($('.nav-' + handle).hasClass('grandchild_nav')) {
          $('.mobile-nav').addClass('grandchild_open');
        }
      } else {
        // set height of container
        var dropdownHeight = $('.nav-' + handle).parent().parent().height();
        var navHeight = (dropdownHeight + 180);
        $('.wmwnav__dropdown').css('height', dropdownHeight);
        $('#page').css('height', navHeight);
  
        // close sub menu
        $('.nav-' + handle).removeClass('nav_open');
  
        if ($('.nav-' + handle).hasClass('child_nav')) {
          $('.mobile-nav').removeClass('child_open');
        } else if ($('.nav-' + handle).hasClass('grandchild_nav')) {
          $('.mobile-nav').removeClass('grandchild_open');
        }
      }
    });
  
    // check wishlist count
    if (typeof iWishCnt != "undefined") {
  
        if (iWishCnt > 0) {
          $('.wmwnav__icons-wishlist').addClass('is-visible');
        } else {
          $('.wmwnav__icons-wishlist').removeClass('is-visible');
        }
  
         $('.iwishRemoveBtn').on('click', function() {
  
            setTimeout(function() {
              if (iWishCnt > 0) {
                $('.wmwnav__icons-wishlist').addClass('is-visible');
              } else {
                $('.wmwnav__icons-wishlist').removeClass('is-visible');
              }
            }, 1000)
          });
    }
  
    $('.link-register').click(function() {
      var url=location.href;
      localStorage.setItem("url",url);
    });


  // usp banner width based on logo

  window.theme = window.theme || {};

  theme.uspWidth = (function() {
    function _bindEvents() {
      $(document).ready(function() {
        _resizeUsp();
      })

      $(window).on('resize', function() {
        _resizeUsp();
      });
    }

    function _resizeUsp() {
      var logoWidth = $('.logo-image').width();
      var curveWidth = (logoWidth + 75);

      $('.wmwusp__curve').css('width', curveWidth + 'px');
      $('.wmwusp__container').css('width', 'calc(100% - ' + curveWidth + 'px)');
      $('.wmwusp__container').css('margin-left', curveWidth + 'px');
    }

    function init() {
      _bindEvents();
    }

    return {
      init: init
    }
  })();

  theme.uspWidth.init();
})
